import { GridValidRowModel } from "@mui/x-data-grid-pro";
//YATAY;446221;18032025
const WaterLowExampleRows: GridValidRowModel[] = [
  {
    id: 1,
    field1: "fielda",
    field2: "fieldb",
    field3: "fieldc",
    field4: "fieldd",
    field5: "fielde",
    date: "datf",
    update: "updatg",
    delete: "deleth",
  },
  {
    id: 2,
    field1: "fieldj",
    field2: "fieldk",
    field3: "fieldl",
    field4: "fieldm",
    field5: "fieldn",
    date: "datp",
    update: "updatü",
    delete: "deleta",
  },
  {
    id: 3,
    field1: "fields",
    field2: "fieldd",
    field3: "fieldg",
    field4: "fieldv",
    field5: "fieldc",
    date: "datz",
    update: "updatx",
    delete: "deletv",
  },
  {
    id: 4,
    field1: "field23",
    field2: "field46",
    field3: "field56",
    field4: "field43",
    field5: "field52",
    date: "date1",
    update: "update2",
    delete: "delete3",
  },
];

export default WaterLowExampleRows;
